import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/poggers/error-page/error-page_cord.svg")